import { render, staticRenderFns } from "./OpenBankingAppDeleteModal.vue?vue&type=template&id=23735ede"
import script from "./OpenBankingAppDeleteModal.vue?vue&type=script&lang=js"
export * from "./OpenBankingAppDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports